import {h} from 'preact';
import Button from '@components/common/Button'
import Message from '@components/common/Message'

const i18nText = upi.i18n.getTextFromKey;
const lblShowingNumberOf = i18nText( 'lbl-showingNumberOf', 'Showing %CURSOR% of %TOTAL%' );
const lblErrorGettingReviews = i18nText( 'lbl-errorGettingReviews' );
const lblLoadMore = i18nText( 'lbl-loadMore' );

const Pagination = ( {loading = false, error, cursorPosition, totalCount, onLoadMore = () => {}} ) => {
    if ( totalCount === 0 ) {
        return null;
    }

    return (
        <div className="md:my-8 w-full text-center" data-testid="review-pagination">
            {error &&
            <Message fail className="my-8">
                {lblErrorGettingReviews}
            </Message>
            }
            <h1 className="mb-4">
                {lblShowingNumberOf
                    .replace( '%CURSOR%', Math.min( cursorPosition, totalCount ) )
                    .replace( '%TOTAL%', totalCount )
                }
            </h1>
            {cursorPosition < totalCount ?
                <Button primary loading={loading} data-testid="test-loadMore" className="w-full md:w-64"
                        onClick={onLoadMore}>
                    {lblLoadMore}
                </Button> :
                null}
        </div>
    );
};

export default Pagination;